export const settingsHubEn = {
  title: 'Settings',
  subtitle: 'All configuration areas of the tenant in one place.',
  personal: 'Personal',
  configuration: 'Configuration',
  empty: 'No configuration areas are available for your role.',
  areas: {
    setup: {
      title: 'Setup & setup check',
      description: 'Guided tenant setup, progress, verification runs and approval.',
    },
    profile: {
      title: 'My profile',
      description: 'Name, language and display preferences.',
    },
    security: {
      title: 'Security',
      description: 'Password, two-factor authentication and active sessions.',
    },
    company: {
      title: 'Company profile',
      description: 'Master data, bank details, VAT ID and default document texts.',
    },
    users: {
      title: 'Users & roles',
      description: 'Team accounts, RBAC permission matrix and mandatory two-factor.',
    },
    pdfDesigner: {
      title: 'PDF designer',
      description: 'Drag & drop templates for quotes, orders and invoices.',
    },
    documentHeaders: {
      title: 'Customer data in document headers',
      description: 'Manage fields, sections and visibility separately for each document type.',
    },
    accounting: {
      title: 'DATEV & Intrastat',
      description: 'SKR03/04 account mapping, advisor and client number, reporting runs.',
    },
    banking: {
      title: 'Banking & reconciliation',
      description: 'AISP, synchronization, matching, account mapping, and secure import profiles.',
    },
    whatsapp: {
      title: 'WhatsApp Business API',
      description: 'Meta Cloud API tokens, webhooks and message templates.',
    },
    notifications: {
      title: 'Notifications',
      description: 'Rules for minimum stock, best before warnings and payments.',
    },
    salesRules: {
      title: 'Sales rules & customer care',
      description: 'Simulate recommendations, maintain thresholds and schedule automatic runs.',
    },
    translations: {
      title: 'Languages & translations',
      description: 'Manage tenant-specific terminology and protected names.',
    },
    customFields: {
      title: 'Custom fields & GoBD vault',
      description: 'Dynamic additional fields and tamper-evident change logs.',
    },
    system: {
      title: 'System & backups',
      description: 'SMTP test, database backups, import/export and telemetry.',
    },
  },
  links: {
    setup: 'Open setup',
    company: 'Edit company data',
    users: 'User management',
    roles: 'Roles & permissions',
    securityLog: 'Security log',
    templates: 'Document templates',
    documentHeaders: 'Customer data in document headers',
    accounting: 'Account mapping',
    datev: 'DATEV export',
    intrastat: 'Intrastat report',
    banking: 'Configure banking',
    whatsapp: 'Connection & templates',
    notifications: 'Alert rules',
    salesRules: 'Manage sales rules',
    translations: 'Translation glossary',
    customFields: 'Custom fields',
    auditVault: 'GoBD vault',
    system: 'System health',
    errorLogs: 'Error center',
    mailBackups: 'Mail server & backups',
    dataHub: 'Import & export',
  },
} as const;
